(function () {
  'use strict';
  var modal = document.getElementById('mylilan-add-to-cart-modal');
  if (!modal || modal.dataset.initialized === 'true') return;
  modal.dataset.initialized = 'true';

  var titleEl = modal.querySelector('[data-mylilan-atc-product-title]');
  var imageEl = modal.querySelector('[data-mylilan-atc-image]');
  var variantEl = modal.querySelector('[data-mylilan-atc-variant]');
  var priceEl = modal.querySelector('[data-mylilan-atc-price]');
  var compareEl = modal.querySelector('[data-mylilan-atc-compare]');
  var quantityEl = modal.querySelector('[data-mylilan-atc-quantity]');
  var countEl = modal.querySelector('[data-mylilan-atc-count]');
  var cartLink = modal.querySelector('[data-mylilan-atc-cart]');
  var closeButton = modal.querySelector('[data-mylilan-atc-close]');
  var lastFocus = null;

  function money(cents, currency) {
    var amount = Number(cents);
    if (!Number.isFinite(amount)) return '';
    try {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: currency || 'USD' }).format(amount / 100);
    } catch (e) {
      return '$' + (amount / 100).toFixed(2);
    }
  }

  function imageUrl(item) {
    var value = item && (item.featured_image || item.image);
    if (value && typeof value === 'object') value = value.url || value.src || '';
    return typeof value === 'string' ? value : '';
  }

  function variantText(item) {
    if (!item) return '';
    var title = item.variant_title;
    if (title && title !== 'Default Title') return title;
    if (Array.isArray(item.options_with_values)) {
      var values = item.options_with_values
        .filter(function (option) { return option && option.name !== 'Title' && option.value && option.value !== 'Default Title'; })
        .map(function (option) { return option.value; });
      if (values.length) return values.join(' · ');
    }
    if (Array.isArray(item.variant_options)) {
      var opts = item.variant_options.filter(function (value) { return value && value !== 'Default Title'; });
      return opts.join(' · ');
    }
    return '';
  }

  function openModal(addedItem, cart) {
    if (!addedItem) return;
    var cartLine = null;
    if (cart && Array.isArray(cart.items)) {
      var id = addedItem.variant_id || addedItem.id;
      cartLine = cart.items.find(function (line) { return String(line.id) === String(id); }) || null;
    }
    var item = cartLine || addedItem;
    var productTitle = item.product_title || addedItem.product_title || item.title || addedItem.title || 'Item';
    titleEl.textContent = productTitle;

    var variant = variantText(addedItem) || variantText(item);
    variantEl.textContent = variant;
    variantEl.hidden = !variant;

    var src = imageUrl(item) || imageUrl(addedItem);
    if (src) {
      imageEl.src = src;
      imageEl.alt = productTitle;
      imageEl.hidden = false;
    } else {
      imageEl.removeAttribute('src');
      imageEl.alt = '';
      imageEl.hidden = true;
    }

    var currentPrice = item.final_price != null ? item.final_price :
      (item.price != null ? item.price : addedItem.final_price);
    var currency = (cart && cart.currency) || 'USD';
    priceEl.textContent = money(currentPrice, currency);

    var comparePrice = Number(item.compare_at_price || addedItem.compare_at_price || 0);
    if (!comparePrice && Number(item.original_price) > Number(currentPrice)) comparePrice = Number(item.original_price);
    if (comparePrice > Number(currentPrice)) {
      compareEl.textContent = money(comparePrice, currency);
      compareEl.hidden = false;
    } else {
      compareEl.textContent = '';
      compareEl.hidden = true;
    }

    var addedQuantity = Number(addedItem.quantity) || 1;
    quantityEl.textContent = 'Quantity: ' + addedQuantity;

    var count = cart && Number.isFinite(Number(cart.item_count)) ? Number(cart.item_count) : null;
    if (count === null) {
      var bubble = document.querySelector('.cart-bubble__text, [data-cart-count]');
      count = bubble ? (parseInt(bubble.textContent, 10) || addedQuantity) : addedQuantity;
    }
    if (countEl) countEl.textContent = String(count);
    if (cartLink && cartLink.href) {
      /* Keep the theme's localized cart URL. */
    }

    lastFocus = document.activeElement;
    if (!modal.open) modal.showModal();
    document.documentElement.classList.add('mylilan-atc-open');
    if (closeButton) closeButton.focus({ preventScroll: true });
  }

  function closeModal() {
    if (modal.open) modal.close();
  }

  if (closeButton) closeButton.addEventListener('click', closeModal);
  modal.addEventListener('click', function (event) {
    if (event.target === modal) closeModal();
  });
  modal.addEventListener('close', function () {
    document.documentElement.classList.remove('mylilan-atc-open');
    if (lastFocus && typeof lastFocus.focus === 'function' && document.contains(lastFocus)) {
      lastFocus.focus({ preventScroll: true });
    }
  });

  /* Watch Shopify's normal AJAX add-to-cart request without replacing its response or changing cart data. */
  var nativeFetch = window.fetch.bind(window);
  window.fetch = function (input, init) {
    var requestUrl = typeof input === 'string' ? input : (input && input.url) || '';
    var parsedUrl;
    var isAddRequest = false;
    var cartJsonPath = '/cart.js';
    try {
      parsedUrl = new URL(requestUrl, window.location.href);
      isAddRequest = /\/cart\/add(?:\.js)?\/?$/.test(parsedUrl.pathname);
      if (isAddRequest) cartJsonPath = parsedUrl.pathname.replace(/\/cart\/add(?:\.js)?\/?$/, '/cart.js');
    } catch (e) {}

    var request = nativeFetch(input, init);
    if (!isAddRequest) return request;

    return request.then(function (response) {
      if (response && response.ok) {
        response.clone().json().then(function (data) {
          if (!data || data.status) return;
          var addedItem = Array.isArray(data.items) ? data.items[0] : data;
          if (!addedItem || !(addedItem.id || addedItem.variant_id || addedItem.product_id)) return;
          /* Desktop uses the theme's native side cart drawer. Only mobile/tablet opens this confirmation modal. */
          if (window.matchMedia('(min-width: 750px)').matches) {
            return;
          }
          nativeFetch(cartJsonPath, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
            .then(function (cartResponse) { return cartResponse && cartResponse.ok ? cartResponse.json() : null; })
            .catch(function () { return null; })
            .then(function (cart) { openModal(addedItem, cart); });
        }).catch(function () {});
      }
      return response;
    });
  };
})();
